import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouterProps } from '../../../utils/with-router-props'
import moment from 'moment'
import InputElement from '../../../utils/input'
import SHSForm from '../../../utils/shs-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { callApi, fetchFileViaApi } from '../../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'

const FORM_TYPE_LABELS = {
    private_dinner: 'Private Dinner',
    multi_day: 'Multi-Day',
    weekly_meal: 'Weekly Meal'
}

const LeadHeader = (props) => {
    const { dispatch, navigate, leadForm } = props
    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('admin/tickets', 'CREATE', null, 'from-lead'), formData, formId))
    }

    const successFX = (ticketId) => {
        navigate(buildRoutePath(routes.adminTicketsView.path, { ticketId }))
    }

    const handlePdfDownload = () => {
        dispatch(fetchFileViaApi(
            apiResourceEndpoint('admin/lead-forms', 'VIEW', leadForm.id, 'pdf'),
            {},
            `tivity-inquiry-${leadForm.id}.pdf`
        ))
    }

    return (
        <div className="lead-header">
            <div className="info">
                <h1>
                    {leadForm.eventName}
                </h1>
                <span className="client">
                    {`${leadForm.firstName} ${leadForm.lastName}`}
                </span>
                <span className="date">
                    {leadForm.endDate
                        ? `${moment(leadForm.eventDate).format('MMM D')} – ${moment(leadForm.endDate).format('MMM D, Y')}`
                        : moment(leadForm.eventDate).format('MMMM D, Y')
                    }
                </span>
                <span className="status">{leadForm._computed.statusDisplay}</span>
                {leadForm.formType && (
                    <span className="lead-type-badge">{FORM_TYPE_LABELS[leadForm.formType] || leadForm.formType}</span>
                )}
            </div>
            <div className="actions">
                <span className="lead-action" title="Download PDF" onClick={handlePdfDownload} style={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={['far', 'file-pdf']} />
                </span>
                { leadForm._computed.ticketId
                    ? <Link to={buildRoutePath(routes.adminTicketsView.path, { ticketId: leadForm._computed.ticketId })}>View Ticket {leadForm._computed.ticketId}</Link>
                    : <>
                        <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Convert to Ticket">
                            <InputElement
                                type="hidden"
                                id="leadFormId"
                                default={leadForm.id}
                                extraClass="standalone"
                                label={null} />
                        </SHSForm>
                    </>
                }
            </div>
        </div>
    )
}

export default withRouterProps(connect()(LeadHeader))
